import { useCallback, useEffect, useState } from 'react';
import { FileEntity } from '../../../types';
import { filesService } from '../../../services/filesService';

export const useAuditReports = (auditId: number | null) => {
  const [files, setFiles] = useState<FileEntity[]>([]);
  const [loadingFiles, setLoadingFiles] = useState(false);

  const loadFiles = useCallback(async () => {
    if (!auditId) return;

    try {
      setLoadingFiles(true);
      const data = await filesService.list({ audit_id: auditId });
      setFiles(data);
    } catch (error) {
      console.error('Fehler beim Laden der Dateien:', error);
    } finally {
      setLoadingFiles(false);
    }
  }, [auditId]);

  useEffect(() => {
    void loadFiles();
  }, [loadFiles]);

  return {
    files,
    setFiles,
    loadingFiles,
    loadFiles,
  };
};
